import { render, staticRenderFns } from "./tab-customClass-editor.vue?vue&type=template&id=21d60ae4&scoped=true"
import script from "./tab-customClass-editor.vue?vue&type=script&lang=js"
export * from "./tab-customClass-editor.vue?vue&type=script&lang=js"
import style0 from "./tab-customClass-editor.vue?vue&type=style&index=0&id=21d60ae4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d60ae4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d60ae4')) {
      api.createRecord('21d60ae4', component.options)
    } else {
      api.reload('21d60ae4', component.options)
    }
    module.hot.accept("./tab-customClass-editor.vue?vue&type=template&id=21d60ae4&scoped=true", function () {
      api.rerender('21d60ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/container-tab/tab-customClass-editor.vue"
export default component.exports